import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Change,
  Reset,
} from "../../../store/async-actions/digitalmarketing/header";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
import DashTable from "./DashTable";
import { Button } from "@mui/material";
import { Col, Row } from "react-bootstrap";
import { BsBoxArrowRight } from "react-icons/bs";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import DateRangePicker from "../../../Component/DigitalMarketing/Forms/DateRangePicker";
import {

  useGetBloodTestsListQuery,
} from "../../../Service/BloodTests";
import moment from "moment";
import { FiFilter } from "react-icons/fi";
import FileSaver from "file-saver";

import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../Component/DigitalMarketing/Toast";
import { BASE_URL } from "../../../Service/api/ApiUrls";
import { useNavigate } from "react-router-dom";


function BloodTests() {
  const [pagination, setpagination] = useState(1);
  const initialstate = {
    startDate: null,
    endDate: null,
  };
  const [date, setDate] = useState(initialstate);
  const [dateRange, setDateRange] = useState(initialstate);
  const { open, message, openSnackBar, type } = useSnackbar();
  const dispatch = useDispatch<any>();
  const [searchValue, setSearchValue] = useState("");
  const [show, setShow] = useState(false);
  const [paramsValue, setParamsValue] = useState({
    date: initialstate,
  });
  const account = useSelector((state: any) => state.auth);
  const navigate = useNavigate();

  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };
  const pagi = {
    pageNo: pagination,
    date: paramsValue?.date,
    name: searchValue,
  };
  useEffect(() => {
    setpagination(1);
  }, [ searchValue]);
  const { data: response,refetch, isLoading }: any = useGetBloodTestsListQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });
  useEffect(() => {
    dispatch(Reset());
  }, [dispatch]);
  const ListFilter = () => {
    if (
      !date?.startDate ||
      date?.startDate === "Invalid date" ||
      date?.endDate !== "Invalid date"
    ) {
      setParamsValue({
        date,
      });
      setShow(true);
      setpagination(1);
    } else {
      openSnackBar("Please select end date!", "error");
    }
  };
 
  useEffect(() => {
    const data: any = {
      first: "BloodTests",
    };
    dispatch(Change(data));
  }, [dispatch]);
 


  const handleDownload = async () => {
    try {
      const authToken = account.token;

      var filterdetails = `?startDate=${date.startDate}&endDate=${date.endDate}&name=${searchValue}`;
      if (
        searchValue === "" &&
        date.startDate === null &&
        date.endDate === null
      ) {
        filterdetails = "";
        // console.log("none");
        // console.log("token",authToken);

      }
      const response = await fetch(
        `${BASE_URL}/blood_test_export${filterdetails}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      // Check if the request was successful (status code in the range of 200-299)
      if (response.ok) {
        const blob = await response.blob();
        const currentDate = new Date();
        const formattedDate = `${currentDate.getFullYear()}-${(
          currentDate.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}-${currentDate
          .getDate()
          .toString()
          .padStart(2, "0")}`;

        FileSaver.saveAs(blob, `bloodtest-${formattedDate}.xlsx`); // console.log('Download successful!');
      } else {
        // Handle error
        // console.error('Download failed:', response.status, response.statusText);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const onHandleChange = (event) => {
    const { name, value } = event.target;
    if (name === "date") {
      setDate({
        startDate: moment(value[0]).format("YYYY-MM-DD"),
        endDate: moment(value[1]).format("YYYY-MM-DD"),
      });
      setDateRange(value);
    } 
  };

  const ClearFilter = () => {
    setShow(false);
    setDate(initialstate);
    setDateRange(initialstate);
    setParamsValue({ date: initialstate });
    setSearchValue("");
  };
  return (
    <React.Fragment>
      <div>
        <Toast open={open} type={type} message={message} />
        <Row className="mb-3">
          <Col md={5} className="mb-3">
            <SearchBox
              value={searchValue}
              onChange={(event) => onChangeSearch(event)}
            />
          </Col>
          <Col md={7} className="d-flex mb-3 justify-content-between">
            <DateRangePicker
              date={dateRange}
              key_name="date"
              DisableFutureDate="true"
              handleChange={onHandleChange}
            />{" "}
            &nbsp;&nbsp;
            
            <div className="filter f-14 mx-2 cursor ">
              <Button variant="contained" onClick={ListFilter} id="btn-add">
                {" "}
                <FiFilter />
                &nbsp; Filter
              </Button>
            </div>
            {show && (
              <p
                className="clear-filter f-14 mb-0 mt-1 mx-2 cursor"
                onClick={ClearFilter}
              >
                X Clear filters
              </p>
            )}
          </Col>
        </Row>
          <Row className="mb-3">
            <Col>
           
              {/* <Button
                className="right mb-2"
                variant="contained"
                id="btn" style={{width:"160px"}}
                onClick={() => navigate("add")}
              >
                + New Appointment
              </Button> */}
              <Button
              className="right mb-2"
              variant="contained"
              onClick={handleDownload}
              id="btn"
            >
              <BsBoxArrowRight className="me-2" /> Export
            </Button>
            </Col>
          </Row>
     
       
        <DashTable customer={response} isLoading={isLoading}           refetch={refetch}
 />
        {!isLoading &&<Pagination
          setpagination={setpagination}
          pagination={pagination}
          data={response}
        />}
      </div>
    </React.Fragment>
  );
}

export default React.memo(BloodTests);
